export default __webpack_public_path__ + "static/media/checkin.827e121c.png";